import type { ReactNode } from 'react'

import { Typography, type TTypographyProps } from '@/src/elements/text/Typography'
import { cn } from '@/src/general/utils/cn'

export const Paragraph = ({ className, ...otherProps }: TTypographyProps): ReactNode => (
  <Typography colors="secondary" contrast="high" className={cn('block pb-2 text-mdlc', className)} {...otherProps} />
)
